<script setup>
import HomeActions from '@src/components/HomeActions.vue';
import StudyInfoHeader from '@src/components/main-application-header/StudyInfoHeader.vue';

import ContourControls from '@src/components/tools/contour/ContourControls.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const itemHeight = 40; // Height of each item in the header
const router = useRouter();

const showContourControls = computed(() =>
  ['/analysis'].includes(router.currentRoute.value.path),
);
const showStudyInfoHeader = computed(() =>
  ['/analysis'].includes(router.currentRoute.value.path),
);
</script>

<template>
  <header class="flex py-2">
    <StudyInfoHeader
      v-if="showStudyInfoHeader"
      :style="`height: ${itemHeight}px;`"
    />
    <div class="ml-auto flex gap-2">
      <ContourControls v-if="showContourControls" />
      <HomeActions :style="`height: ${itemHeight}px;`" />
    </div>
  </header>
</template>
